export const FIREBASE_STORAGE_URL =
  "https://firebasestorage.googleapis.com/v0/b/edge2k22.appspot.com/o/";

export const AWS_S3_URL = "https://edge-results.s3.ap-south-1.amazonaws.com/";
